export default {
    smsSent: 'Your SMS has been successfully sent. If the SMS hasn`t arrived, you can resend the SMS in {n} seconds.',
    buttons: {
        save: 'Save',
        resend: 'Resend SMS',
    },
    fields: {
        token: {
            label: 'Enter Verification code from SMS',
            placeholder: '******',
        },
    },
    errors: {
        user_invalid_change_mobile_token: 'Verification code is invalid!',
    },
}
